'use client'

import type { ReactElement } from 'react'

import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

import type { StoreFrontDto } from '@b-stock/listing-api-client'

import { UnAuthWarning } from '@/buyer-portal/components/features/unAuthWarning'
import { PageWidth } from '@/components/PageWidth'
import type { CmsSellerProfile } from '@/helpers/api/fetchPayload'

import SignInAbout from './content/SignInAbout'
import { CostcoAbout } from './costcoAbout'

/** Hand-built sign-in folds by storefront slug; a slug with no entry falls through to the CMS. */
const LEGACY_SIGN_IN_ABOUT_BY_SLUG: Record<string, () => ReactElement> = {
  costco: CostcoAbout,
}

const UnAuthWarningWrap = styled(PageWidth)`
  margin-bottom: 5rem;
`

export default function SignInWarning({
  storefront,
  cmsSellerProfile,
  legacyCostcoStyleAboutEnabled,
}: {
  storefront: StoreFrontDto
  cmsSellerProfile?: CmsSellerProfile | null
  legacyCostcoStyleAboutEnabled?: boolean
}) {
  const intl = useIntl()
  const LegacySignInAbout = legacyCostcoStyleAboutEnabled
    ? LEGACY_SIGN_IN_ABOUT_BY_SLUG[storefront.slug.toLowerCase()]
    : undefined
  const reasonText = intl.formatMessage(
    { id: 'AuctionList.unAuthReason' },
    { seller: storefront.name }
  )

  return (
    <UnAuthWarningWrap>
      <UnAuthWarning reason={reasonText}>
        {/* A hand-built fold wins over the CMS when the LD allowlist names this storefront, as on
            the About tab; otherwise the CMS toggle decides. */}
        {LegacySignInAbout ? (
          <LegacySignInAbout />
        ) : cmsSellerProfile?.aboutOnSignInEnabled ? (
          <SignInAbout
            profile={cmsSellerProfile}
            sellerName={storefront.name}
          />
        ) : null}
      </UnAuthWarning>
    </UnAuthWarningWrap>
  )
}
